module.exports = __webpack_public_path__ + "media/newstyle/images/icon-download-e4e6a77f85080736ef98bbde0049d23d.svg";